/**
 * Which of its four faces a live's Watch page shows (prototype screens 11 to
 * 14): before the room opens, the lobby from ten minutes before, the live, and
 * after. The payload says where the live stood when the page loaded; the room
 * says when it moves on (its `state` messages, or a socket closed because the
 * live ended). A live only ever moves forward, so the later word wins.
 */
import type { LiveState } from "../../shared/live-protocol";

type LiveView = "before" | "lobby" | "live" | "after";

const ORDER: Record<LiveState, number> = { scheduled: 0, live: 1, ended: 2 };

/** The later of two states: a stale word can never move a live back. */
export function laterState(a: LiveState, b: LiveState | null | undefined): LiveState {
  return b && ORDER[b] > ORDER[a] ? b : a;
}

/** The face for a live in `state`, at `nowMs`, whose room opens at `opensAtMs`. */
export function liveView(state: LiveState, opensAtMs: number, nowMs: number): LiveView {
  if (state === "ended") return "after";
  if (state === "live") return "live";
  return nowMs >= opensAtMs ? "lobby" : "before";
}

/** "04:59": minutes and seconds to the start, for the lobby's clock. Null once it has passed. */
export function lobbyClock(startsAtMs: number, nowMs: number): string | null {
  const left = Math.ceil((startsAtMs - nowMs) / 1000);
  if (left <= 0) return null;
  const m = Math.floor(left / 60);
  const s = left % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
